<template>
  <section id="Selected" class="mt-1 mb-2 text-white">
    <div class="text-right cursor--pointer pr-1" @click="closeTab()">
      <i class="fa fa-times-circle"></i> Sulje
    </div>
    <div class="c-header--label text-white">Valitut varusteet</div>
    <template v-if="selected && selected.length > 0">
      <div v-for="item in selected" :key="item.uid" class="mr-1 mb-2">
        <h5>
          {{splitTitle(item.name)[0]}},
          {{dealerPrice(item.price, item.dealer_prices)}}
        </h5>
        <div class="support-text" style="margin-bottom: .4em;">{{splitTitle(item.name)[1]}}</div>

        <div class="row mt-1">
          <div v-if="item.image_uri" class="col-4 c-card-img">
            <div class="c-card-img-container">
              <img v-if="item.image_uri" :src="item.image_uri" :alt="item.manufacturer_code" class="card-img-top">
            </div>
          </div>
          <div class="col support-text mb-1">
            Tuotekoodi: {{item.manufacturer_code}}<br>
            <span v-if="item.package_code">Pakettikoodi: {{item.package_code}}</span>
          </div>
        </div>
      </div>
      <div class="mt-3">
        <button @click="clearSelected()" class="btn btn-sm"><i class="fa fa-trash" aria-hidden="true"></i> Tyhjennä valitut</button>
        <button @click="saveSelected()" v-if="!basket.id" class="btn btn-sm btn-t1-primary"><i class="fa fa-save" aria-hidden="true"></i> Tallenna</button>
      </div>

      <div v-if="basket.emailSuccess" class="alert alert-success mt-2" role="alert">
        Viesti lähetetty.
      </div>

      <div v-if="basket.id" class="mt-2">
        Tämän kokoelman tunniste on: <code class="text-white" style="letter-spacing: .5px; font-size: 100%;">{{basket.id}}</code>. <br>
        Voit palauttaa valitsemasi kokoelman käyttäen tunnistetta. Kopioi tunniste talteen tai lähetä se sähköpostilla haluamaasi osoitteeseen:

        <form @submit.prevent="emailSelected" class="mt-1">
          <div class="form-group">
            <label class="text-white" for="email">Sähköpostiosoite</label>
            <input v-model="basket.email" type="email" class="form-control" id="email" required>
          </div>
          <div class="form-group">
            <label class="text-white" for="message">Saateviesti</label>
            <textarea v-model="basket.msg" class="form-control" id="message" rows="3"></textarea>
          </div>
          <button type="submit" class="btn btn-sm btn-t1-primary"><i class="fa fa-paper-plane" aria-hidden="true"></i> Lähetä</button>
        </form>
      </div>
    </template>
    <template v-else>
      <div class="mb-2">Ole hyvä ja valitse jokin lisävaruste.</div>
    </template>
    <form @submit.prevent="restoreSelected" class=" mt-3 pt-2 border-top border-secondary">
      <div class="c-header--label text-white">Tuo aiemmin tallennettu kokoelma</div>
      <div class="form-group">
        <label class="sr-only" for="id">Kokoelman tunnus</label>
        <input v-model="restore.id" type="text" class="form-control" id="id" placeholder="kokoelman tunnus" minlength="6" maxlength="6" required>
      </div>
      <button type="submit" class="btn btn-sm text-white" style="background: #4caf50;"><i class="fa fa-download" aria-hidden="true"></i> Tuo</button>
    </form>

    <div v-if="restore.date" class="support-text mt-1">Tämä kokoelma oli tallennettu: {{restore.date}}</div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import axios from 'axios'
import _ from 'lodash'

export default {
  name: 'Selected',

  data () {
    return {
      basket: {
        id: null,
        email: null,
        emailSuccess: false,
        msg: null
      },
      restore: {
        id: null,
        date: null
      }
    }
  },

  computed: {
    ...mapGetters({
      selected: 'getSelected',
      dealer: 'getDealer'
    })
  },

  watch: {
    selected () {
      this.$emit('AccIDs', this.selected)
    }
  },

  methods: {
    clearSelected: function () {
      // reset everything
      this.basket.id = null
      this.basket.emailSuccess = false
      this.restore.id = null
      this.restore.date = null
      this.$store.dispatch('updateSelected', null)
    },

    /* TEST
    parseSelected: function () {
      let output = this.selected.map(function (e) {
        return [e.name, e.image_uri]
      })
      console.log(output)
    },
    */

    saveSelected: function () {
      this.basket.id = this.generateUID()
      const acc = _.map(this.selected, 'guid').join(',')
      const date = new Date()
      const p = [this.basket.id, acc, date.toISOString().split('T')[0]].join(';')
      console.log(p)
      axios
        .post(process.env.VUE_APP_PROD_PHP_BACKEND + '/collection.php', p)
        .then(response => { console.log(response.data) })
        .catch(error => { console.log(error) })
    },

    emailSelected: function () {
      // create an array of selected items details
      let selection = this.selected.map(function (e) {
        return [e.name, e.image_uri]
      })
      selection = JSON.stringify(selection)

      const p = [this.basket.email, this.basket.id, this.basket.msg, selection].join(';')
      const self = this
      axios
        .post(process.env.VUE_APP_PROD_PHP_BACKEND + '/collection_mailer.php', p)
        .then(response => {
          // console.log(response.status)
          self.basket.id = null // reset saving
          if (response.status === 200) {
            self.basket.emailSuccess = true // show success message
          }
        })
        .catch(error => { console.log(error) })
    },

    restoreSelected: function () {
      this.basket.id = null // reset saving
      const self = this
      axios
        .get(process.env.VUE_APP_PROD_PHP_BACKEND + '/collection.php?tunniste=' + this.restore.id)
        .then(response => {
          const t = response.data.split(';')
          self.findAccessoriesByUID(t[1])
          self.restore.date = t[2]
        })
        .catch(error => { console.log(error) })
    },

    closeTab: function () {
      this.$emit('closeTab', true)
    },

    /*
     * @param {String} — Title
     * @returns {Array} — Returns title in two parts if split successful
     */
    splitTitle: function (str) {
      const re = (/[:,.]\s/)
      const i = str.search(re)

      if (i < 0) {
        return [str]
      } else {
        return [str.substring(0, i), str.substring(i + 2)]
      }
    },

    /*
     * @returns {String} — Returns 6-character alphanumeric sequence
     */
    generateUID: function () {
      let a = (Math.random() * 46656) | 0
      let b = (Math.random() * 46656) | 0
      a = ('000' + a.toString(36)).slice(-3)
      b = ('000' + b.toString(36)).slice(-3)
      return (a + b).toUpperCase()
    },

    findAccessoriesByUID: function (a) {
      a = a.split(',')
      const p = []

      a.forEach(function (id) {
        axios
          .get(process.env.VUE_APP_PROD_API + '/accessories/' + id + '?api_token=' + process.env.VUE_APP_PROD_API_TOKEN)
          .then(response => {
            p.push(...response.data)
          })
          .catch(error => { console.log(error) })
      })
      this.$store.dispatch('updateSelected', p)
    },

    dealerPrice: function (p, dp) {
      if (this.dealer !== 'none') {
        if (dp[this.dealer]) {
          return dp[this.dealer] + ' €'
        } else {
          return p + ' €'
        }
      } else {
        return p + ' €'
      }
    }
  }
}
</script>

<style scoped>
.c-card-img {
  position: relative;
  width: 100%;
}

.c-card-img:after {
  content: "";
  display: block;
  padding-bottom: 100%; /* aspect-ratio 1:1 */
}

.c-card-img-container {
  position: absolute;
  top: 0; bottom: 0; left: 0; right: 0;
  text-align: center;
}

.card-img-top {
  width: auto;
  height: 100%;
}

.c-header--label {
  margin-bottom: 8px;
}
</style>
